import TextField from "@/src/components/custom-fields/TextField";
import CustomButton from "@/src/lib/ui/Button";
import { useState } from "react";
import { useHODMutation } from "@/src/lib/hooks/useHODMutation";
import { cartApiService } from "@/src/lib/api-services/cartApiServices";
import { useToast } from "@/src/lib/hooks/useToast";
import { useSelector } from "react-redux";
import Progressbar from "@/src/components/loading";
import { updateDiscountAmount } from "@/src/lib/store/pet-ct-appointment-new/slice";
import { useDispatch } from "react-redux";

const CouponCode = ({ setIsApplyCoupon, onClose }) => {
    const [couponCode, setCouponCode] = useState("");
    const dispatch = useDispatch();
    const checkoutId = useSelector(
        (state) => state?.appointmentNew?.checkoutId
    );

    const { showCustomToast } = useToast();
    const { mutate: applyCouponMutate, isLoading } = useHODMutation(
        (data) => cartApiService.applyCoupon(data),
        {
            onSuccess: (data) => {
                dispatch(updateDiscountAmount(data?.data?.discountAmount)); // dispatch the discount amount to the store

                showCustomToast(
                    data?.message || "Coupon applied successfully",
                    "success"
                );
                setCouponCode("");
                setIsApplyCoupon(data?.data?.voucherCode || "");
                onClose();
            },
            onError: (error) => {
                showCustomToast(
                    error?.response?.data?.message || error?.message,
                    "error"
                );
                console.log(error, "error");
            },
        }
    );
    const applyCouponHandler = () => {
        if (couponCode.trim() === "") {
            showCustomToast("Please enter a coupon code", "error");
            return;
        }
        applyCouponMutate({
            checkoutId: checkoutId,
            voucherCode: couponCode,
        });
    };
    return (
        <div>
            {/* <p className="block text-lg font-semibold text-gray-600 ">
                Apply Coupon
            </p>
            <p className="text-xs text-gray-600 mb-2 ">
                Enter the coupon code to get a discount on your appointment.
            </p> */}
            <div className="flex flex-row gap-2">
                <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    name="coupon"
                    label="Enter Coupon Code"
                    className="bg-white"
                    value={couponCode.toUpperCase()}
                    onChange={(e) => setCouponCode(e.target.value)}
                    //placeholder="Enter coupon"
                />
                <CustomButton
                    disabled={isLoading}
                    variant="contained"
                    onClick={applyCouponHandler}
                    className="whitespace-nowrap"
                >
                    {isLoading ? <Progressbar size={16} /> : "Apply"}
                </CustomButton>
            </div>
        </div>
    );
};

export default CouponCode;
